<template>
  <!-- <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
      <template v-for="(item, index) in tabList">
        <template v-if="item.children && item.children.length">
          <el-sub-menu :index="navIndex" v-if="item.children.length > 0" @click="dianji(item)">
            <template #title>{{ item.name || item.orgCode || item.sonName }}</template>
            <recursive-menu @menuItemClick="handleOpendw" :tabList="item.children"></recursive-menu>
          </el-sub-menu>
        </template>
        <template v-else>
          <el-menu-item :index="navIndex" @click="dianji(item)">{{ item.sonName || item.orgCode || item.sonName}}</el-menu-item>
        </template>
      </template>
    </el-menu> -->
  <el-sub-menu 
    v-if="item.children && item.children.length > 0" :index="navIndex" 
    @click="xialkuang(item,navIndex)" 
    :class="navIndex == xialaIndex? 'xuanzhongxila':'xuanzhongxilaqu'"
    >
    <template #title>
      <!-- 有数据的列表 -->
      <span   @click="dianji(item)">
        <!-- 字典-文件夹图标 -->
        <!-- <span  v-if="item.id && identification == '字典'">***</span>  -->
        <img src="./images/wenjianjia.png" alt="" class="img-box" v-if="item.id && identification == '字典'">
        <!-- 人头数据图标 -->
        <Avatar class="tubiao" v-if="item.id && identification != '字典'"></Avatar> 
        <img :src="item.imgUrl" alt="" class="img-icons-box" v-if="item.imgUrl">
        {{ item.alias || item.username || item.name }}
      </span>
    </template>
    <template v-if="item.children && item.children.length > 0">
      <RecursiveMenu :navIndex="navIndex + '-' + subIndex" @menuItemClick="handleOpendw"
      @xialkuang="xialkuang"
      :identification="identification"
        v-for="(subItem, subIndex) in item.children" :item="subItem" :key="subItem.id"></RecursiveMenu>
    </template>
    <el-menu-item v-else :index="navIndex" @click="dianji(item)">{{ item.alias|| item.username || item.sonName ||
      item.deviceName || '- * -' +222  }}</el-menu-item>
  </el-sub-menu>
  <el-menu-item v-else :index="navIndex" @click="dianji(item)">
    <!-- 字典--文件图标 -->
    <img src="./images/wenjian.png" alt="" class="img-box"  v-if="item.laiyuan == 1 && identification == '字典' ">
    <!-- 字典--文件夹图标 -->
    <img src="./images/wenjianjia.png" alt="" class="img-box" v-if="item.id && !item.laiyuan && identification == '字典'">
    <!-- 该用户下可能还有数据列表 -->
      <Avatar class="tubiao" v-if="item.id && !item.laiyuan && identification != '字典'"></Avatar> 
      {{item.alias|| item.username || item.sonName ||item.deviceName || item.name || '宝贝' }}
  </el-menu-item>
</template>
  
<script>
import { Avatar } from "@element-plus/icons-vue"; // 图标
import { jiuxueKing } from '@/assets/api/user.js'


export default {
  name: 'RecursiveMenu',
  props: {
    item: {
      type: Object,
      required: true
    },
    tabList: {
      type: Array,
      default: () => []
    },
    identification: {
      type: String,
      default: ''

    },
    navIndex: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      defaultActive: '1-1', // 设置默认激活的菜单项
      zilever: '',
      yemian: '',
      xialaIndex: 1,
      kingData:{}
    };
  },
  components: {
    Avatar,
    RecursiveMenu: () => import('./node.vue'), // 递归引入自身组件，实现无限级导航
  },
  mounted () {
  },
  methods: {
    xialkuang (item,index) {
      // console.log('下拉框',item,index);
      this.$emit('xialkuang',item)
      this.xialaIndex = index
    },
    xilayangshi (status,index) {
      // if ( this.xialaIndex == index ) {
      //   return {
      //     backgroundColor:  '#1BC896 ',
      //     color: '#1BC896 ',
      //   }
      // } else {
      // return{
      //   backgroundColor:  ' ',
      //   color: '',
      // }
      // }
    },
    dianji(item) {
      if (item.sonName  == '九学王'){
        this.jiuxuewangClick()
      }
      this.$emit('menuItemClick', item)
    },
    jiuxuewangClick(){
      const params = {
        userId:JSON.parse(localStorage.getItem('user')).id,
        userType:'pzteacher'
      }
      jiuxueKing(params).then((res) => {
        this.kingData = res.data.data
        this.$confirm('请确认是否要跳转到九学王页面?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        window.open(`${this.kingData.path}?token=${this.kingData.token}`)
                    }).catch((err) => {

                    });
      }).catch((err)=> {
        console.error('九学王跳转失败', err)
      })
    },

    handleOpen(key, keyPath) {
      this.zilever = key
    },
    handleOpendw(zilever) {
      this.$emit('menuItemClick', zilever)
    },
    handleClose(key, keyPath) {
    }
  }
};
</script>
<style lang="scss" scoped>
// background-color
.xuanzhongxila {
  // background-color:  #1BC896 !important;
}
.tubiao {
  width: 12px;
}
.img-box {
  width: 16px;
}
.img-icons-box {
  width: 18px;
}
:deep() {
  .el-sub-menu__title * {
    vertical-align: middle;
  }
  .el-sub-menu__title {
    // color: #F2F2F2;
  }
  .el-menu-item {
    // color: #909399;
    color: black;
    font-size: 15px;
  }
}
.bos {}
</style>